import { AbstractControl, ValidatorFn } from '@angular/forms';

export class CommonValidators {
  static equal(compenentPath1: string, componentPath2: string): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const control1Value = group.get(compenentPath1)?.value;
      const control2Value = group.get(componentPath2)?.value;
      return control1Value === control2Value ? null : {'not-equal': true};
    };
  }
}
